import { type ReactNode } from 'react';

import Typography from '@liquidweb-dev/undercurrent/Typography';

const DestroyNote = ({ children }: { children: ReactNode }) => {
	return (
		<Typography variant="body-md">
			<Typography fontWeight={500} variant="body-md">
				Note:{' '}
			</Typography>{' '}
			{children}
		</Typography>
	);
};

export default DestroyNote;
